<template>
  <div id="aboutad">
    <div class="banner"></div>
    <div class="h1_title">
      <h1>关于巨掌数据</h1>
    </div>
    <div class="about_title">
      <p>巨掌成立于2014年，以AI+大数据智能算法为广告主提供精准移动效果营销服务，是国内头部的平台型解决方案服务商。管理团队深耕行业多年，致力于打造多方共赢的健康可持续发展生态体系。</p>
      <p>公司凭借庞大自有流量、优质的品牌广告资源、强大的移动广告技术和丰富的客户资源，为广告主提供优质的国内外资源和高转化率推广服务。我们的具体业务包括iOS全案优化服务、ASA投放优化服务、互动广告营销、信息流媒体合作等一站式无线营销解决方案，使广告主获得价值最大化。</p>
    </div>
    <!-- <div class="banner_ban">
      <div class="banner_cont">
        <section>
          <img src="./aboutadjuz3.png" alt="">
          <p>连续创业者，亿起联联合创始人&CTO，公司于2014年</br>以4.8亿估值实现退出。</p>
          <p>多年移动互联网营销平台管理及研发经验，引领了移动<br>营销产品形态及研发风潮。</p>
          <p>2014年创立巨掌，作风稳健，专注技术研发创新，<br>属技术驱动型负责人。</p>
        </section>
        <section>
          <img src="./aboutadjuz4.png" alt="">
          <p>连续创业者，亿起联营销负责人，公司于2014年<br>
            以4.8亿估值实现退出。
          </p>
          <p>多年移动互联网企业运营及营销管理经验。</p>
          <p>2014年创立巨掌，属运营及营销驱动型负责人，<br>擅长营销与运营模式创新。</p>
        </section>
      </div>
    </div> -->
    <div class="look">
      <div>
        <h1>巨掌数据认为</h1>
        <p>
          只有专注于内在的修炼，务实地去钻研探究，</br>
          才会开启更多营销可能。</br>
          面对现在行业浮躁与不安 ，</br>
          我们应让营销回归本质。</br>
          让每一次营销都产生应有的真实效果，</br>
          并为客户创造实际价值让客户真正感受到营销的魅力所在。
        </p>
      </div>
      <img src="./aboutadjuz5.png" alt="">
    </div>
    <div class="h1_title" style="margin-top:100px">
      <h1>巨掌团队</h1>
    </div>
    <div class="ad_video">
      <video-player ref="videoPlayer" :options="playerOptions"></video-player>
    </div>
    <div class="bigevent">
      <div class="h1_title">
        <h1>巨掌发展大事件</h1>
      </div>
      <div class="eventlist">
        <div>
          <p v-for="(ele,index) in eventlist" :key="index">
            <span>
              {{ele}}
            </span>
            <i :class="{activei: eventindex == index}" @click="changeevent(index)"></i>
          </p>
        </div>
      </div>
    </div>
    <div class="bigeventbom">
      <div class="box" id="box_list">
        <div class="box_list" v-for="(ele,index) in bigeventlist" :key="index">
          <h1>{{ele.date}}</h1>
          <ul>
            <li v-for="(val,ky) in ele.list" :key="ky">
              <span>{{val.date}}</span>
              <img src="./aboutadjuz8.png" alt="">
              <p>{{val.conts}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "https://static.adjuz.net/adjuz-website/adjuz5ye1.mp4", //url地址
          },
        ],
        poster: require("./aboutadjuz6.png"), //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, //当前时间和持续时间的分隔符
          durationDisplay: false, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: false, //全屏按钮
        },
      },
      eventlist: ["现在", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
      eventindex: 0,
      bigeventlist: [
        {
          date: "2022年",
          list: [
            { date: "2022.01", conts: "巨掌数据在广州举办iOS生态研讨会。" },
          ],
        },
        {
          date: "2021年",
          list: [
            { date: "2021.06", conts: "ASA中国区业务上线巨掌第一时间进入。" },
            { date: "2021.07", conts: "巨掌数据联合Appsflyer在上海举办后IDFA时代研讨会。" },
          ],
        },
        {
          date: "2020年",
          list: [
            { date: "2020.02", conts: "巨掌手机游戏联合运营发行业务上线。" },
            { date: "2020.01", conts: "联合人民网举办互联网安全发展峰会。" },
          ],
        },
        {
          date: "2019年",
          list: [
            { date: "2019.10", conts: "巨掌游戏SaaS业务正式上线" },
            {
              date: "2019.07",
              conts: "巨掌ASMaster数据平台升级为“巨掌数据”。",
            },
            { date: "2019.04", conts: "巨掌5周年庆典。" },
          ],
        },
        {
          date: "2018年",
          list: [
            { date: "2018.12", conts: "小果互动官网初版正式上线。" },
            {
              date: "2018.01",
              conts: "互动宝项目正式开始售卖。",
            },
          ],
        },
        {
          date: "2017年",
          list: [
            { date: "2017.12", conts: "杭州分公司成立" },
            {
              date: "2017.07",
              conts: "巨掌广告旗下快兑宝项目成功上线",
            },
            {
              date: "2017.05",
              conts: "巨掌广告旗下互动广告平台，互动宝成功上线",
            },
          ],
        },
        {
          date: "2016年",
          list: [
            {
              date: "2016.12",
              conts: "巨掌广告成功上线ASMaster智能投放与监测平台",
            },
            {
              date: "2016.10",
              conts: "巨掌广告开始成功代理投放苹果ASM业务",
            },
            {
              date: "2016.05",
              conts: "巨掌广告上海、广州分公司相继成立",
            },
          ],
        },
        {
          date: "2015年",
          list: [
            {
              date: "2015.3",
              conts:
                "巨掌移动广告平台日覆盖突破100万，手机用户累计浏览1000万次",
            },
          ],
        },
        {
          date: "2014年",
          list: [
            {
              date: "2014.7",
              conts: "巨掌移动广告平台开发测试完成正式上线。",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  components: {},
  created() { },
  destroyed() { },
  mounted() { },
  methods: {
    //切换巨掌大事件
    changeevent(index) {
      this.eventindex = index;
      let dom = document.getElementById("box_list");
      $("#box_list").animate({ left: index * -400 + "px" }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
#aboutad {
  width: 100%;
  .banner {
    width: 100%;
    background: url("./aboutadjuz1.png") no-repeat center center;
    background-size: cover;
    height: 420px;
  }
  .h1_title {
    width: 100%;
    text-align: center;
    margin: 70px 0 50px;
    h1 {
      font-weight: 600;
      font-size: 36px;
      color: #333;
      text-align: center;
      position: relative;
      margin-bottom: 60px;
      letter-spacing: 4px;
      &::after {
        position: absolute;
        content: "";
        width: 70px;
        height: 4px;
        background: #409eff;
        bottom: -16px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .about_title {
    width: 1200px;
    margin: 0 auto 80px;
    p {
      font-size: 18px;
      color: #666;
      line-height: 50px;
      text-indent: 40px;
    }
  }
  .banner_ban {
    width: 100%;
    height: 734px;
    background: url("./aboutadjuz2.png") no-repeat center center;
    background-size: cover;
    .banner_cont {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      section {
        box-sizing: border-box;
        padding-top: 70px;
        img {
          width: 490px;
          margin-bottom: 25px;
        }
        p {
          position: relative;
          box-sizing: border-box;
          padding-left: 60px;
          font-size: 16px;
          line-height: 40px;
          color: #fff;
          &::after {
            position: absolute;
            left: 25px;
            top: 16px;
            display: block;
            width: 8px;
            height: 8px;
            background: #409eff;
            content: "";
            transform: rotate(45deg);
          }
        }
      }
    }
  }
  .look {
    width: 1200px;
    margin: 100px auto 0;
    display: flex;
    justify-content: space-between;
    div {
      h1 {
        font-size: 36px;
        color: #333;
        position: relative;
        margin-bottom: 60px;
        letter-spacing: 4px;
        &::after {
          position: absolute;
          content: "";
          width: 70px;
          height: 4px;
          background: #409eff;
          bottom: -16px;
          left: 0;
        }
      }
      p {
        font-size: 20px;
        color: #666;
        line-height: 40px;
      }
    }
    img {
      width: 600px;
      height: auto;
    }
  }
  .ad_video {
    width: 1200px;
    margin: 0 auto 100px;
    height: 560px;
    overflow: hidden;
  }
  .bigevent {
    width: 100%;
    height: 318px;
    background: url("./aboutadjuz7.png") no-repeat center center;
    background-size: cover;
    overflow: hidden;
    h1 {
      color: #fff !important;
    }
    .eventlist {
      width: 1200px;
      margin: 20px auto;
      position: relative;
      padding-top: 10px;
      &::before {
        display: block;
        content: "";
        width: 800px;
        border-bottom: 2px solid #8b919d;
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
      }
      div {
        display: flex;
        justify-content: center;
        p {
          margin: 0 35px;
        }
        span {
          display: block;
          font-size: 16px;
          line-height: 20px;
          color: #fff;
          margin-left: -6px;
        }
        i {
          display: block;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: #8b919d;
          margin-top: 16px;
          cursor: pointer;
          position: relative;
          &.activei {
            &::after {
              content: "";
              width: 14px;
              height: 14px;
              background: #fff;
              display: block;
              top: 50%;
              left: 50%;
              border-radius: 50%;
              transform: translate(-50%, -50%);
              position: absolute;
            }
          }
        }
      }
    }
  }
  .bigeventbom {
    width: 1200px;
    height: 380px;
    background: url("./aboutadjuz9.png") no-repeat center center;
    background-size: cover;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    .box {
      display: flex;
      height: 380px;
      left: 0;
      top: 0;
      position: absolute;
      .box_list {
        width: 400px;
        h1 {
          font-size: 32px;
          color: #333;
          margin: 60px 0;
        }
        ul {
          li {
            align-items: flex-start;
            display: flex;
            margin-bottom: 26px;
            span {
              color: #409eff;
            }
            img {
              width: 40px;
              margin: 0 10px;
            }
            p {
              color: #666;
              line-height: 40px;
              margin-top: -14px;
              box-sizing: border-box;
              padding-right: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
#aboutad {
  video {
    outline: none;
    border: none;
    width: 100% !important;
    height: 560px !important;
    object-fit: fill;
  }
  .vjs-poster {
    background-size: cover;
  }
  .vjs-big-play-button {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    border: none;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    .vjs-icon-placeholder {
      width: 110px;
      height: 110px;
      border-radius: 50%;
      &::before {
        font-size: 40px;
        line-height: 90px;
      }
    }
  }
  .vjs-control-bar {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aboutAdjuz/index.vue